module.exports = __webpack_public_path__ + "svg/dotnet.914d1e.svg";